export const SUB_REGIONS: Record<string, string[]> = {
  AMER: ['CANADA', 'LATAM','IND (Key)','IND (Trans)', 'ENT', 'SCALE', 'OTHERS'],
  EMEA: ['UKI', 'MEA', 'CENTRAL', 'SOUTH WESTERN', 'OTHERS'],
  JAPAC: ['ANZ', 'JAPAN', 'SEA', 'OTHERS'],
}; 

export const RDOTS: Record<string, string> = {
  AMER: '#4f9cf9',
  EMEA: '#a78bfa',
  JAPAC: '#34d399',
  SCALE: '#4f9cf9',
  IND: '#38bdf8',
  ENT: '#0ea5e9',
  CANADA: '#7dd3fc',
  LATAM: '#93c5fd',
  OTHERS: '#bae6fd',
  UKI: '#a78bfa',
  MEA: '#34d399',
  CENTRAL: '#f59e0b',
  ANZ: '#34d399',
  JAPAN: '#f87171',
  SEA: '#60a5fa',
};

export function regionBucket(r: string): string {
  if (!r) return 'EMEA';
  if (r.includes('JAPAN') || r.includes('ANZ') || r.includes('SEA') || r.includes('APAC')) return 'JAPAC';
  if (r.includes('GERMANY')) return 'Germany';
  if (r.includes('UK')) return 'UK';
  return r.includes('AMER') || r.includes('CANADA') || r.includes('LATAM') ? 'AMER' : 'EMEA';
}
